type FileTypeMime = {
  extension: string;
  mimeTypes: string[];
};

export const fileTypes: FileTypeMime[] = [
  // PDF documents
  {
    extension: 'pdf',
    mimeTypes: ['application/pdf'],
  },
  {
    extension: 'pdfa',
    mimeTypes: ['application/pdf'], // PDF/A uses the standard PDF MIME type
  },

  // Images
  {
    extension: 'png',
    mimeTypes: ['image/png'],
  },
  {
    extension: 'jpeg',
    mimeTypes: ['image/jpeg'],
  },
  {
    extension: 'jpg',
    mimeTypes: ['image/jpeg'],
  },
  {
    extension: 'tiff',
    mimeTypes: ['image/tiff'],
  },
  {
    extension: 'tif',
    mimeTypes: ['image/tiff'],
  },

  // Office documents
  {
    extension: 'docx',
    mimeTypes: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  },
  {
    extension: 'doc',
    mimeTypes: ['application/msword'],
  },
  {
    extension: 'dotx',
    mimeTypes: ['application/vnd.openxmlformats-officedocument.wordprocessingml.template'],
  },
  {
    extension: 'docm',
    mimeTypes: ['application/vnd.ms-word.document.macroEnabled.12'],
  },
  {
    extension: 'xlsx',
    mimeTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  },
  {
    extension: 'xls',
    mimeTypes: ['application/vnd.ms-excel'],
  },
  {
    extension: 'xlsm',
    mimeTypes: ['application/vnd.ms-excel.sheet.macroEnabled.12'],
  },
  {
    extension: 'pptx',
    mimeTypes: ['application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  },
  {
    extension: 'ppt',
    mimeTypes: ['application/vnd.ms-powerpoint'],
  },
  {
    extension: 'pptm',
    mimeTypes: ['application/vnd.ms-powerpoint.presentation.macroEnabled.12'],
  },
];

export const PbkNutrientSupportedMimeTypes: string[] = [...new Set(fileTypes.flatMap((type) => type.mimeTypes))];

/** Lower-case file extensions the viewer can render — used to gate previewability when a MIME type is unavailable. */
export const PbkNutrientSupportedExtensions: string[] = [...new Set(fileTypes.map((type) => type.extension))];
